import { render, staticRenderFns } from "./13.vue?vue&type=template&id=b2af585e&scoped=true&"
var script = {}
import style0 from "./13.vue?vue&type=style&index=0&id=b2af585e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2af585e",
  null
  
)

export default component.exports